export const CHAT_TYPOGRAPHY_STORAGE_KEY = "myaifriend.chat-typography.v1";

export const CHAT_FONT_OPTIONS = [
  {
    id: "manrope",
    label: "Manrope",
    description: "Фирменный и современный",
    css: '"Manrope Variable", "Manrope", ui-sans-serif, system-ui, sans-serif',
  },
  {
    id: "system",
    label: "Системный",
    description: "Привычный для устройства",
    css: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  {
    id: "soft",
    label: "Мягкий",
    description: "Дружелюбный и округлый",
    css: '"Trebuchet MS", "Segoe UI", Arial, sans-serif',
  },
  {
    id: "literary",
    label: "Литературный",
    description: "Для спокойного чтения",
    css: 'Georgia, "Times New Roman", serif',
  },
] as const;

export const CHAT_SIZE_OPTIONS = [
  { id: "compact", label: "Мелкий", shortLabel: "А", size: 14, lineHeight: 1.55 },
  { id: "normal", label: "Обычный", shortLabel: "А", size: 15, lineHeight: 1.7 },
  { id: "large", label: "Крупный", shortLabel: "А", size: 17, lineHeight: 1.7 },
  { id: "extra-large", label: "Очень крупный", shortLabel: "А", size: 19, lineHeight: 1.75 },
] as const;

export type ChatFontId = (typeof CHAT_FONT_OPTIONS)[number]["id"];
export type ChatSizeId = (typeof CHAT_SIZE_OPTIONS)[number]["id"];

export interface ChatTypographyPreference {
  font: ChatFontId;
  size: ChatSizeId;
}

export const DEFAULT_CHAT_TYPOGRAPHY: ChatTypographyPreference = {
  font: "manrope",
  size: "normal",
};

const FONT_IDS = new Set<string>(CHAT_FONT_OPTIONS.map((option) => option.id));
const SIZE_IDS = new Set<string>(CHAT_SIZE_OPTIONS.map((option) => option.id));

export function parseChatTypography(raw: string | null): ChatTypographyPreference {
  if (!raw) return DEFAULT_CHAT_TYPOGRAPHY;
  try {
    const value = JSON.parse(raw) as Partial<ChatTypographyPreference>;
    if (!FONT_IDS.has(value.font ?? "") || !SIZE_IDS.has(value.size ?? "")) {
      return DEFAULT_CHAT_TYPOGRAPHY;
    }
    return value as ChatTypographyPreference;
  } catch {
    return DEFAULT_CHAT_TYPOGRAPHY;
  }
}

export function fontOption(font: ChatFontId) {
  return CHAT_FONT_OPTIONS.find((option) => option.id === font) ?? CHAT_FONT_OPTIONS[0];
}

export function sizeOption(size: ChatSizeId) {
  return CHAT_SIZE_OPTIONS.find((option) => option.id === size) ?? CHAT_SIZE_OPTIONS[1];
}
